import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  createSelfCheckoutUrl,
  confirmSelfCheckoutUrl,
} from "./keylessService";

import AlertModalManager from "../../components/alert-modal-wraper/alert-modal-manager";
import Loading from "../../components/Loading";
import { useKeylessToken } from "./KeylessPage";

export function KeylessSelfCheckout({ handleNextStep, keylessToken }) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return null;
    hasRun.current = true;

    createSelfCheckoutUrl(keylessToken)
      .then((res) => {
        window.location.href = res.redirectUrl;
      })
      .catch((err) => {
        setIsLoading(false);
        const messageKey = err.response?.data ?? "generic_error";
        AlertModalManager.openModal(
          { title: t(messageKey), message: "" },
          () => {}
        );
      });
  }, [t, keylessToken, handleNextStep]);

  return <Loading active={isLoading} />;
}

export function KeylessSelfCheckoutConfirmPage(props) {
  const keylessToken = useKeylessToken();

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return null;
    hasRun.current = true;

    confirmSelfCheckoutUrl(keylessToken)
      .then((res) => {
        props.history.replace(`/keyless?token=${keylessToken}`);
      })
      .catch((err) => {
        setIsLoading(false);
        const messageKey = err.response?.data ?? "generic_error";
        AlertModalManager.openModal(
          { title: t(messageKey), message: "" },
          () => {}
        );
      });
  }, [t, keylessToken]);

  return <Loading active={isLoading} />;
}
